import { render, staticRenderFns } from "./examineBuyer.vue?vue&type=template&id=6275259c&scoped=true&"
import script from "./examineBuyer.vue?vue&type=script&lang=js&"
export * from "./examineBuyer.vue?vue&type=script&lang=js&"
import style0 from "./examineBuyer.vue?vue&type=style&index=0&id=6275259c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6275259c",
  null
  
)

export default component.exports